import { defineStore } from 'pinia'
import {consumeAccountOAuth} from '@/scripts/accountOAuth'
export const useCallbackStore = defineStore('callback', {
    // a function that returns a fresh state
    state: () => ({
        provider: null
    }),
    // optional getters
    getters: {

    },
    // optional actions
    actions: {
        async callback(provider, code, state) {
            const code_verifier = consumeAccountOAuth(provider, state)
            if (typeof code !== 'string' || !code) {
                throw new Error('Die Google-Anmeldung wurde abgebrochen. Bitte versuchen Sie es erneut.')
            }
            return this.apiClient.post(
                `/auth/callback`,
                {provider, code, code_verifier},
                {_skipAuthRefresh: true, _skipUnauthorizedHandling: true}
            );
        },
    },
})
